module.exports = __webpack_public_path__ + "static/img/game-img-gx.f42ae82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/game-img-gx.png
// module id = CB2M
// module chunks = 0